module.exports = "<md-dialog> <md-dialog-content> <md-toolbar> <div class=md-toolbar-tools> <md-button class=md-icon-button ng-click=close()> <i class=\"icon mdi-navigation-close i-20\"></i> </md-button> </div> </md-toolbar> <div class=\"row title text-center\"> <div class=col-md-12> <h3 class=text-azul>¡Atención!</h3> <p>{{errorMessage}}</p> </div> </div> <div class=\"row text-center\"> <div class=col-md-12> <md-button class=\"btn btn-fw btn-cancel\" ng-click=close()>Volver</md-button> </div> </div> </md-dialog-content> </md-dialog>";


//////////////////
// WEBPACK FOOTER
// ./src/app/u-faculty/workPlanParametrization/activities/modalActivitesSetedUpError.html
// module id = 216
// module chunks = 0